export default {
  get_current_session_status(state) {
    return state.current_session_status
  },
  get_current_session_highlight_tag(state){
    if( state.current_session_status=='preparing'){
      return []
    }else if(state.current_session_status=='registering'){

    }else if(state.current_session_status=='starting'){

    }else if(state.current_session_status=='ending'){}
    else {
      return []
    }
  },
  get_ajax_count(state) {
    return state.ajax_spin_count
  },
  get_stage_status_list(state){
    return state.stage_status_list
  },
  get_current_language(state){
    const language = {
      ENGLISH: "en",
      简体中文: "zh-CN",
      繁體中文: "zh-TW"
    }
    return language[state.language]
  },
  get_place_map(state){
    return state.place_map
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js